import React from "react";
import { ComingSoonPage } from "@/pages/ComingSoonPage";
import { BarChart3 } from "lucide-react";

export default function ReportsPage() {
  return (
    <ComingSoonPage
      title="Reports"
      description="Business analytics, revenue reports, and performance insights."
      icon={BarChart3}
      accent="#FFED00"
    />
  );
}
